import request from "request-promise-native";
import _ from "@shared/scripts/utils/underscore-extensions";
import { isEmptyValue } from "../utils/antd_tools";
// 注意项目组件版本 避免多版本共存
import { message } from "antd";

// === 通用设置 ===
const PROTOCOL = window.location.protocol;
const WWWHost = window.location.host;

// === 参数序列化 ===
const toQueryString = (obj, prefix = "") => {
  const str = [];
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    const value = obj[key];
    if (isEmptyValue(value)) continue;
    const k = prefix ? `${prefix}[${key}]` : key;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (!isEmptyValue(item)) {
          str.push(`${encodeURIComponent(k)}[]=${encodeURIComponent(item)}`);
        }
      }
    } else if (typeof value === "object") {
      const nested = toQueryString(value, k);
      if (nested) str.push(nested);
    } else {
      str.push(`${encodeURIComponent(k)}=${encodeURIComponent(value)}`);
    }
  }
  return str.join("&");
};

// === 响应拦截处理函数 ===
function handleResponse(response) {
  // 你可以在这里统一处理响应数据（成功情况）
  return response;
}

// === 错误拦截统一处理函数 ===
function handleError(error) {
  const { statusCode } = error.response || {};

  switch (statusCode) {
    case 401:
      console.warn("未登录或登录已过期");
      if (!_.isEmpty(window.currentUser)) {
        message.error("登录已过期");
        location.reload();
      }
      break;
    case 403:
      console.warn("无权限访问");
      break;
    case 500:
      console.error("服务器错误");
      break;
    default:
      console.error("接口发生异常");
  }
}

// === 通用请求封装 ===
const requestWrap = async (uri, params, method = "GET") => {
  const upperMethod = method.toUpperCase();
  let qs = "";

  if (upperMethod === "GET" && params) {
    qs = toQueryString(params);
    if (qs) {
      uri += uri.includes("?") ? "&" + qs : "?" + qs;
    }
  }

  try {
    const response = await request({
      method: upperMethod,
      uri,
      body: upperMethod !== "GET" ? params : undefined,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      },
      withCredentials: true,
      json: true,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// === POST 表单封装 ===
const formPost = async (uri, form, method = "POST") => {
  try {
    const response = await request({
      method,
      uri,
      form,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
        "X-CSRF-Token": (document.querySelector(
          "meta[name=csrf-token]"
        ) as HTMLMetaElement).content,
      },
      withCredentials: true,
      json: true,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// 上传二进制文件专用
const post2File = async (uri, body, method = "POST") => {
  try {
    const response = await fetch(uri, {
      method,
      body,
      credentials: "include",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    // fetch 不会主动抛异常，非 2xx 需要手动抛
    if (!response.ok) {
      // 构造一个错误对象，方便 handleError 使用
      const error: any = new Error(`HTTP error! status: ${response.status}`);
      error.response = response;
      throw error;
    }

    // 假设响应是 JSON
    const data = await response.json();

    // 统一处理响应数据
    return handleResponse(data);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export { PROTOCOL, WWWHost, requestWrap, formPost, post2File };
